import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonService } from 'src-adisco/services/common.service';
import { HomepageService } from 'src-adisco/services/homepage.service';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { ActivatedRoute } from "@angular/router";
import { UserService } from 'src/app/admin/core/services/user.service';

@Component({
  selector: 'app-create-edit-prospect',
  templateUrl: './create-edit-prospect.component.html',
  styleUrls: ['./create-edit-prospect.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class CreateEditProspectComponent implements OnInit {
  list: any[] = [];
  visibleRow: boolean = false;
  infoCustomerForm: FormGroup;
  listTypeUser: any[] = [];
  listTypeLegalEntity: any[] = [];
  // contactData: any[] = [
  //   {
  //     Fonction: 'Directeur Commercial',
  //     Prenom: 'LIZOT',
  //     Nom: 'Dominique',
  //     Telephone: '0164052023',
  //     Portable: '0677341101',
  //     Email: 'contact@brosseriethomas.com',
  //   },
  //   {
  //     Fonction: 'Secrétaire commerciale',
  //     Prenom: 'CABOT',
  //     Nom: 'Alexandra',
  //     Telephone: '0164052023',
  //     Portable: '',
  //     Email: 'logistique@brosseriethomas.com@brosseriethomas.com',
  //   },
  //   {
  //     Fonction: 'Directeur Commercial',
  //     Prenom: 'LIZOT',
  //     Nom: 'Dominique',
  //     Telephone: '0164052023',
  //     Portable: '0677341101',
  //     Email: 'contact@brosseriethomas.com',
  //   },
  //   {
  //     Fonction: 'Secrétaire commerciale',
  //     Prenom: 'CABOT',
  //     Nom: 'Alexandra',
  //     Telephone: '0164052023',
  //     Portable: '',
  //     Email: 'logistique@brosseriethomas.com@brosseriethomas.com',
  //   },
  // ];
  nameFile: string = '';
  logoImage: any;
  listCountry: any[] = [];
  currentTab: number = 0;
  userId = localStorage.getItem('userid');
  listIdLinkToLegalEntity: any[] = [];
  listContacts: any[] = [];
  currentUser: any;
  infoContactForm: FormGroup;
  listCivility: any[] = [];
  itemContactEdit: any;
  codeMember: string = '';
  listStatus: any[] = [];
  isEdit: boolean = false;
  currentLegalEntity: any;
  clientData: any;

  constructor(private _fb: FormBuilder, private httpClientService: HttpclientService,
    private _homepageService: HomepageService,
    private _messageService: MessageService,
    private dynamicDocumentService: DynamicDocumentService,
    private _commonService: CommonService,
    private router: Router,
    private _cdf: ChangeDetectorRef,
    private route: ActivatedRoute,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.initForm();
    this.getListCivility();
    this.getListCountry();
    this.getListStatus();
    this.getListTypeOfLegalEntity();
    this.getInfoProfile();

    this.checkEditOrCreate();
  }

  checkEditOrCreate() {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEdit = true;
        this.dynamicDocumentService.findById("dynamic_legal_entity", params['id']).subscribe((editDetail) => {
          const parseFormData = {
            ...editDetail,
            typeOfCustomer: editDetail?.typeOfCustomer?.parameterId,
            country: editDetail?.country?.parameterId
          };

          delete parseFormData['updatingDate'];
          delete parseFormData['creationDate'];
          this.infoCustomerForm.patchValue(parseFormData);
          if (parseFormData?.code) {
            this.clientData = parseFormData;
            this.getListContacts(this.clientData?.code);
          };
        })

      }
    });

  };

  initForm(): void {
    this.infoCustomerForm = this._fb.group({
      id: null,
      code: ['', Validators.required],
      companyName: ['', Validators.required],
      siret: ['', Validators.required],
      vat: '',
      logo: null,
      address: '',
      additionalAddress: '',
      postcode: '',
      city: '',
      country: '',
      phone: '',
      fax: '',
      email: '',
      website: '',
      updatingDate: null,
      creationDate: null,
      typeOfLegalEntity: null,
      typeOfCustomer: null,
      region: null,
      status: null,
      lastModifiedUser: null,
      nafCode: null,
      linkToArticles: null,
      linkToResources: null,
      linkToNaturalPersons: null,
      linkToHeadCatalogPrice: null,
      linkToNews: null,
      memberCatalogSegmentation: null,
      linkToMember: null,
      file: null,
      linkToCustomers: null,
      url: null,
    });
    this.infoContactForm = this._fb.group({
      id: null,
      civility: null,
      creationDate: null,
      updatingDate: null,
      mobile: null,
      address: null,
      additionalAddress: null,
      postcode: null,
      city: null,
      region: null,
      country: null,
      linkToLegalEntity: null,
      dateOfLastConnectionToTheIntranetSite: null,
      firstName: '',
      lastName: '',
      phone: '',
      email: ['', Validators.required],
      job: '',
      status: '',
      role: null,
    });
  }
  getListRole(): void {
    this._commonService.getRole().subscribe({
      next: (res) => {
        this.listStatus = res.map((item: any) => ({
          ...item,
          parameterId: item?.id,
        }));
      },
      error: (error) => { },
    });
  }
  getInfoProfile(): void {
    this._commonService.getUser(this.userId).subscribe({
      next: (res) => {
        this.currentUser = res;

        if (this.currentUser?.linkToLegalEntity) {
          const linkToLegalEntityId = this.currentUser?.linkToLegalEntity?.documentId ?? '';

          this.infoCustomerForm.patchValue({
            linkToMember: [{
              "documentName": "dynamic_legal_entity",
              "documentId": linkToLegalEntityId
            }]
          });

          this._commonService.getInfoMember(linkToLegalEntityId).subscribe({
            next: (res) => {
              this.currentLegalEntity = res;

              this.codeMember = res?.code;
            },
            error: (error) => { },
          });
        }
      },
      error: (error) => { },
    });
  }
  getListTypeOfLegalEntity(): void {
    this._commonService.getTypeOfLegalEntity().subscribe({
      next: (res) => {
        this.listTypeLegalEntity = res.map((type: any) => ({ ...type, label: type?.mapLocalLibelle['fr_FR'] ?? type?.valeur }));
      },
      error: (error) => { },
    });

    this._commonService.getTypeOfCustomer().subscribe({
      next: (res) => {
        this.listTypeUser = res.map((type: any) => ({ ...type, label: type?.mapLocalLibelle['fr_FR'] ?? type?.valeur }));
      },
      error: (error) => { },
    });
  }
  getListCountry(): void {
    this._homepageService.getCountry().subscribe({
      next: (res) => {
        this.listCountry = res.map((item: any) => ({
          ...item,
          label: item.mapLocalLibelle.fr_FR
        }));
      },
      error: (error) => { },
    });
  }
  getListCivility(): void {
    this._commonService.getCivility().subscribe({
      next: (res) => {
        this.listCivility = res.map((item: any) => ({
          ...item,
          label: item?.mapLocalLibelle.fr_FR,
          parameterId: item?.id,
        }));
      },
      error: (error) => { },
    });
  }
  selectImage(event: any): void {
    let selectedFile = event.target.files[0];
    if (!selectedFile) {
      return;
    }
    this.nameFile = selectedFile?.name;
    this.logoImage = selectedFile;
    this.uploadFile(selectedFile);
  }
  uploadFile(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    this.httpClientService
      .postWithHeader(formData, {}, '/resource-files')
      .subscribe({
        next: (resourceFile) => {
          this.infoCustomerForm.patchValue({
            logo: [this.convertFieldImage(resourceFile)]
          })
        },
        error: (error) => {
        },
      });
  }
  convertFieldImage(file: any) {
    return {
      resourceFileId: file.id,
      // name: file.name,
      url: file?.url
    };
  }
  onTabChange(event: any): void {
    this.currentTab = event.index;

  }
  save() {
    if (this.currentTab === 0) {
      if (this.infoCustomerForm.value.country) {

      }
      if (!this.infoCustomerForm.valid) {
        return;
      };

      const foundItemStatus = this.listStatus.find(item => (item.valeur === 'Publié'));

      if (foundItemStatus?.id) {
        this.infoCustomerForm.patchValue({
          status: [foundItemStatus.id],
        })
      };

      const foundLegalEntityType = this.listTypeLegalEntity.find(item => (item.valeur === 'CLIENT'));

      if (foundLegalEntityType?.id) {
        this.infoCustomerForm.patchValue({
          typeOfLegalEntity: [foundLegalEntityType.id],
        })
      };

      this.dynamicDocumentService
        .saveDocument('dynamic_legal_entity', this.infoCustomerForm.value, true)
        .subscribe({
          next: (res) => {
            this.router.navigate(['/gestion/customer-prospect']);
              this._messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: "Les détails de l'utilisateur ont été enregistrés avec succès",
                life: 3000
              });

          },
          error: (err) => {
            this._messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: "Échec de l'enregistrement des détails de l'utilisateur",
              life: 3000
            });
          }
        });
    } else if (this.currentTab === 1) {
      if (!this.infoContactForm.valid) {
        return;
      }

      const saveValue = { ...this.itemContactEdit };

      Object.keys(this.infoContactForm.value).forEach((key) => {
        if (!!this.infoContactForm.value[key]) {
          saveValue[key] = this.infoContactForm.value[key];
        }
      });

      delete saveValue['updatingDate'];
      delete saveValue['creationDate'];

      const foundItemCivilite = this.listCivility.find(item => item.id === this.infoContactForm.value.civility);
      if (foundItemCivilite) {
        saveValue['civility'] = this.mapItem(foundItemCivilite);
      };

      saveValue['createExtranetAccount'] = false;

      if (this.infoContactForm.value?.id) {
        this.saveValueForm(saveValue);

      } else if (this.clientData?.id) {
        saveValue['linkToLegalEntity'] = this.clientData.id;
        this.saveValueForm(saveValue);
      }
    }
  };

  mapItem(item: any) {
    return {
      parameterId: item.id,
      value: item.valeur,
      labels: {
        en_GB: item.mapLocalLibelle.en_GB,
        es_ES: item.mapLocalLibelle.es_ES,
        fr_FR: item.mapLocalLibelle.fr_FR,
        de_DE: item.mapLocalLibelle.de_DE
      }
    };
  }

  getListContacts(code: string): void {
    if (!code) {
      return
    };

    this.dynamicDocumentService
      .find(
        {
          collectionName: 'dynamic_natural_person',
          filters: [
            {
              "fieldName": "linkToLegalEntity",
              "conditions": [
                {
                  "id": 1,
                  "type": "EQUALS",
                  "value": code,
                  "minValue": "",
                  "maxValue": ""
                }
              ]
            }
          ],
          sorts: {},
          page: 1,
          pageSize: 150,
        }
      )
      .subscribe((res: any) => {
        this.listContacts = res?.content;
      })
  };

  getListStatus(): void {
    this._commonService.getStatus().subscribe({
      next: (res) => {
        this.listStatus = res;
      },
      error: (error) => { },
    });
  };


  itemCustomer: any;
  showDialogDelRow(data: any) {
    this.visibleRow = true;
    this.itemCustomer = data;
    this.resetFormContact()
  }
  resetFormContact(): void {
    this.infoContactForm.reset();
    this.itemContactEdit = null;
  }
  confirmDeleteCustomer(): void {
    this._commonService.deleteContactMember(this.itemCustomer?.id).subscribe({
      next: (res) => {
        this.visibleRow = false;
        this.getListContacts(this.clientData?.code);
        this._cdf.detectChanges();
      },
      error: (error) => { },
    });
  }
  editItemContact(item: any) {
    this._commonService.getUser(item?.id).subscribe({
      next: (res) => {
        this.itemContactEdit = res;
        if (this.itemContactEdit) {
          this.patchValueItemContact(this.itemContactEdit);
        }
      },
      error: (error) => { },
    });
  }
  patchValueItemContact(item: any): void {
    this.infoContactForm?.patchValue({
      id: item?.id,
      civility: item?.civility?.parameterId,
      role: item?.role?.parameterId,
      firstName: item?.firstName,
      lastName: item?.lastName,
      phone: item?.phone,
      email: item?.email,
      job: item?.job,
      status: item?.status?.value
    })
  };

  saveValueForm(data: any): void {
    this.dynamicDocumentService
      .saveDocument('dynamic_natural_person', data, true)
      .subscribe({
        next: (res) => {
          if (this.clientData?.code) {
            this.getListContacts(this.clientData.code);
            this.resetFormContact();
            this._cdf.detectChanges();
          }
          this._messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Les contacts ont été enregistrés avec succès",
            life: 3000
          });
        },
        error: (err) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Échec de l'enregistrement du contact",
            life: 3000
          });
        }
      });
  }

  checkDisplaySaveButton() {
    if (this.userService.hasExtranetAccess('fonctions', 'gestion-fournisseurs')) {
      this.infoCustomerForm?.disabled && this.infoCustomerForm.enable();
      this.infoContactForm?.disabled && this.infoContactForm.enable();
      return true;
    } else {
      this.infoCustomerForm?.enabled && this.infoCustomerForm.disable();
      this.infoContactForm?.enabled && this.infoContactForm.disable();
      return false;
    }
  }
}
